export default __webpack_public_path__ + "static/media/person_icon_white_mob.2e1e3de6.png";